import { Route, Routes } from "react-router-dom";
import MainLayout from "../layout/MainLayout";

import NotFound from "../common/NotFound";

import HomePage from "../pages/Home/HomePage";
import CBRProgramPage from "../pages/CBRProgram/CBRProgramPage";
import AboutUs from "../pages/AboutUs/AboutUs";
import ContactsPage from "../pages/Contacts/ContactsPage";
import ResourcesPage from "../pages/Resources/ResourcesPage";
import SupportUsPage from "../pages/SupportUs/SupportUsPage";


function AppRoutes() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/cbr-program" element={<CBRProgramPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/support-us" element={<SupportUsPage />} />
      </Route>

      <Route path="*" element={<NotFound />}></Route>
    </Routes>
  );
}

export default AppRoutes;
